import React from "react";

export const FeaturesEffectsFilters = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={56}
            height={57}
            viewBox="0 0 56 57"
            fill="none"
            {...props}
        >
            <path
                d="M43.096 4.562a12.764 12.764 0 008.137 8.137 12.763 12.763 0 00-8.137 8.137 12.763 12.763 0 00-8.136-8.137 12.763 12.763 0 008.136-8.137z"
                fill="#FE9235"
            />
            <path
                d="M48.109 31.875V30.9l-3.928-.877a23.5 23.5 0 01-17.816-17.815l-.877-3.929h-.976l-.877 3.929A23.5 23.5 0 015.82 30.022l-3.928.877v.976l3.928.877a23.5 23.5 0 0117.816 17.816l.877 3.928h.976l.877-3.928A23.5 23.5 0 0144.18 32.752l3.928-.877z"
                stroke="#32393E"
            />
        </svg>
    )
}
